export class ApplicantService {
    static async setScoreToPF(personalProfileId, options) {
        return await axios.put(`/api/personal-profile/${personalProfileId}/score`, options)
    }
}
